import gql from 'graphql-tag';

export const CREATE_TEXT_WITH_REFERRER = gql`
  mutation createTextWithReferrer (
    $personId: ID!,
    $url: String!,
    $projectId: ID!,
  ){
    CreateTextWithReferrer(
      partyId: $personId,
      url: $url,
      projectId: $projectId,
    ) {
      __typename
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type
      url
    }
  }
`;

export const UPDATE_TEXT = gql`
  mutation updateText(
    $personId: ID!,
    $input: TextInput
  ) {
    UpdateText(
      personId: $personId,
      input: $input
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      project {
        id,
        title,
        status,
        type,
        owners {
          id,
          fullName,
          __typename
        }
      }
      comments {
        id,
        text,
        creationDate {
          formatted
        }
        lastModifiedDate { formatted },
        author {
          id,
          accountId,
          fullName,
          imageDepictions {
            id,
            title,
            type,
            thumbnail { 
              id, 
              file { 
                uri 
                }
              }
            }
          __typename
        }
      }
      genres {
        id,
        name
      }
      contributions {
        id,
        contributor {
          id,
          fullName,
          __typename
        }
        role,
        isCredited,
        creditText,
        featured
      }
      rightShares {
        id,
        percent,
        territoryCode,
        owners {
          id,
          fullName,
          __typename
        }
        controllers {
          id,
          fullName,
          __typename
        }
        administrators {
          id,
          fullName,
          __typename
        }
        for {
          id,
          role
        }
      }
      file {
        id,
        proprietaryId,
        fileName,
        fileType,
        uri,
        size,
        bitDepth,
        bitRate,
        samplingRate,
        codecType
      }
      referrer {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      resourceOf {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      __typename
    }
  }
`;

export const DELETE_TEXT = gql`
   mutation deleteText (
    $personId: ID!,
    $referenceId: ID!
  ) {
    DeleteText(
      personId: $personId,
      referenceId: $referenceId
  ) {
    id
  }
}
`;

export const GET_TEXT = gql`
  query getText(
    $personId: ID!, 
    $projectId: ID!, 
    $referenceId: ID!
  ) {
    Text(
      personId: $personId, 
      projectId: $projectId, 
      referenceId: $referenceId
    ){
      id,
      title,
      subtitle,
      version,
      creationDate {formatted},
      creationDateIsApproximate,
      lastModifiedDate {formatted},
      type,
      proprietaryId,
      proprietaryIdNamespace,
      status,
      url,
      project {
        id,
        title,
        status,
        type,
        owners {
          id,
          fullName,
          __typename
        }
      }
      comments {
        id,
        text,
        creationDate {
          formatted
        }
        lastModifiedDate { formatted },
        author {
          id,
          accountId,
          fullName,
          imageDepictions {
            id,
            title,
            type,
            thumbnail { 
              id, 
              file { 
                uri 
                }
              }
            }
          __typename
        }
      }
      genres {
        id,
        name
      }
      contributions {
        id,
        contributor {
          id,
          fullName,
          __typename
        }
        role,
        isCredited,
        creditText,
        featured
      }
      rightShares {
        id,
        percent,
        territoryCode,
        owners {
          id,
          fullName,
          __typename
        }
        controllers {
          id,
          fullName,
          __typename
        }
        administrators {
          id,
          fullName,
          __typename
        }
        for {
          id,
          role
        }
      }
      file {
        id,
        proprietaryId,
        fileName,
        fileType,
        uri,
        size,
        bitDepth,
        bitRate,
        samplingRate,
        codecType
      }
      referrer {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
      resourceOf {
        __typename,
        ...on Project {
          id,
          title,
          status,
          type,
          owners {
            id,
            fullName,
            __typename
          }
        }
      }
    }
  }
`;